import Vector from '../Vector.js'
import Size from '../Size.js'

class Entity {
    
    constructor() {
        this.position = new Vector(0, 0);
        this.size = new Size(0, 0);
        this.collectionReferences = [];
    }
    
    addCollectionReference(reference) {
        this.collectionReferences.push(reference);
        return this;
    }
    
    destroy() {
        for(const i in this.collectionReferences) {
            const ref = this.collectionReferences[i];
            if(ref.has(this)) {
                ref.remove(this);
            }
        }
    }
    
    tick() {
        //Do nothing, abstract
    }

    draw(ctx) {
        //Do nothing, abstract
    }

    getPosition() {
        return this.position;
    }
    
    setPosition(position) {
        this.position = position;
        return this;
    }

    getSize() {
        return this.size;
    }
    
}

export default Entity
